(function(){
  function boot(){
    var host=document.getElementById('ypam-host');
    if(!host||host._done)return;
    host._done=true;
    var d=host.dataset;
    var DANKE=d.danke||'/pages/danke';
    var LID=d.lid||'';
    var WU=d.wu||'https://yespiece-api.patient-dawn-bd4d.workers.dev';
    var SK=d.sk||'C06EFDHJ2DA';
    var PROD=d.prod||'';
    var KNAME=(d.kname&&d.kname.trim())||'Markus';
    var KTITEL=(d.ktitel&&d.ktitel.trim())||'';
    var BFREI=d.bfrei||'';
    var BKREIS=d.bkreis||'';
    var BPOS=d.bpos||'center top';
    var BZOOM=parseInt(d.bzoom)||100;
    var PROMISE=(d.promise&&d.promise.trim())||'Ich melde mich persönlich in 24 h mit eurem Mockup.';
    var BTNTEXT=(d.btnText&&d.btnText.trim())||'Unverbindlich anfragen';
    var MODALBTNTEXT=(d.modalBtnText&&d.modalBtnText.trim())||BTNTEXT;
    var TRUST1=(d.trust1&&d.trust1.trim())||'Gratis Mockup';
    var TRUST2=(d.trust2&&d.trust2.trim())||'Unverbindlich';
    var TRUST3=(d.trust3&&d.trust3.trim())||'Persönliche Beratung';
    var MEHRHINT=(d.mehrHint&&d.mehrHint.trim())||'Genaue Stückzahl eingeben …';
    var D1=(d.d1&&d.d1.trim())||'unter 4 Wochen';
    var D2=(d.d2&&d.d2.trim())||'1–3 Monate';
    var D3=(d.d3&&d.d3.trim())||'über 3 Monate';
    var D4=(d.d4&&d.d4.trim())||'noch kein Termin';
    var MIN=parseInt(d.min)||10;

    var iosStyle=document.createElement('style');
    iosStyle.textContent=[
      '#ypam-ol *{-webkit-tap-highlight-color:rgba(0,0,0,0)!important}',
      '#ypam-ol .ypam-chip:active{background:#272726!important;color:#fff!important;border-color:#272726!important}',
      '#ypam-ol .ypam-chip:not(.sel):active{background:#E0E3E6!important;color:#272726!important;border-color:#6E7378!important}',
      '#ypam-ol #ypam-minus:active,#ypam-ol #ypam-plus:active{background:#6E7378!important}'
    ].join('');
    document.head.appendChild(iosStyle);

    var s=document.createElement('style');
    s.textContent=
      '#ypam-ol{display:none;position:fixed;top:0;left:0;right:0;bottom:0;z-index:2147483647;background:rgba(39,39,38,.65);backdrop-filter:blur(6px);align-items:center;justify-content:center;padding:16px}'+
      '#ypam-ol.on{display:flex}'+
      '#ypam-bx{background:#fff!important;width:100%!important;max-width:580px!important;max-height:90vh!important;overflow-y:auto!important;overflow-x:visible!important;position:relative!important;box-shadow:0 24px 80px rgba(0,0,0,.22)!important}'+
      '#ypam-ol *{font-family:var(--font-body-family)!important;box-sizing:border-box}'+
      '#ypam-x{position:absolute!important;top:12px!important;right:12px!important;background:none!important;border:none!important;cursor:pointer!important;color:rgba(0,0,0,.4)!important;font-size:20px!important;z-index:200!important;line-height:1!important;padding:4px!important;width:auto!important;height:auto!important;display:flex!important;align-items:center!important;justify-content:center!important;box-shadow:none!important;border-radius:0!important;overflow:visible!important;clip-path:none!important;-webkit-clip-path:none!important}'+
      '#ypam-x:hover{color:#282727!important}'+
      '#ypam-hd{background:#D8DDE0!important;display:flex!important;align-items:center!important;gap:20px!important;padding:20px 28px 20px 24px!important;overflow:hidden!important}'+
      '#ypam-hi{display:flex!important;flex-direction:column!important;gap:5px!important}'+
      '.ypam-ey{font-size:11px!important;font-weight:700!important;letter-spacing:.1em!important;text-transform:uppercase!important;color:#4a5560!important;display:block!important}'+
      '.ypam-nm{font-size:22px!important;font-weight:800!important;color:#1a1a19!important;display:block!important;letter-spacing:-.02em!important;line-height:1.1!important;font-style:italic!important;text-transform:none!important}'+
      '.ypam-ro{font-size:13px!important;color:#4a5560!important;display:block!important;font-weight:600!important}'+
      '.ypam-pm{font-size:12px!important;color:#4a5560!important;display:block!important;line-height:1.5!important}'+
      '.ypam-if{width:80px!important;height:100px!important;object-fit:cover!important;border-radius:6px 6px 0 0!important;display:block!important;align-self:flex-end!important}'+
      '.ypam-ik{width:56px!important;height:56px!important;border-radius:50%!important;object-fit:cover!important;border:2px solid rgba(39,39,38,.12)!important;display:block!important}'+
      '.ypam-ii{width:56px!important;height:56px!important;border-radius:50%!important;background:#6E7378!important;display:flex!important;align-items:center!important;justify-content:center!important;font-size:22px!important;font-weight:700!important;color:#fff!important}'+
      '#ypam-bd{padding:24px 28px 28px;background:#fff}'+
      '.ypam-sc{font-size:15px!important;font-weight:700!important;letter-spacing:0!important;text-transform:none!important;color:#272726!important;margin-bottom:12px!important;display:flex!important;align-items:center!important;gap:8px!important;font-family:var(--font-body-family)!important}'+
      '.ypam-sc-num{display:inline-flex!important;flex:0 0 auto!important;width:24px!important;height:24px!important;background:#C7D64F!important;color:#272726!important;font-family:var(--font-heading-family),"Barlow Condensed",sans-serif!important;font-size:12px!important;font-weight:800!important;align-items:center!important;justify-content:center!important;flex-shrink:0!important;letter-spacing:0!important}'+
      '.ypam-sc::after{content:""!important;flex:1!important;height:1px!important;background:#E0E3DE!important}'+
      '#ypam-sk{margin-bottom:18px!important}'+

      /* ── CHIPS: AUSGEBLENDET ─────────────────────────────────────
         Um Chips wieder einzublenden:
         1. Die nächste display:none-Regel auf display:flex ändern
         2. Im HTML-Block unten den auskommentierten #ypam-chips-Block einkommentieren
         3. Im submit-Handler unten die Chips-Validierung einkommentieren
      ─────────────────────────────────────────────────────────── */
      '#ypam-chips{display:none!important}'+

      '.ypam-chip{flex:1!important;padding:7px 2px!important;font-size:11px!important;font-weight:700!important;border:1.5px solid #E0E3DE!important;background:#F8F9F7!important;color:#6E7378!important;cursor:pointer!important;text-align:center!important;min-width:0!important;transition:all .15s!important;font-family:var(--font-body-family)!important;clip-path:none!important;-webkit-clip-path:none!important;border-radius:8px!important;height:auto!important;min-height:0!important;line-height:1.2!important}'+
      '#ypam-stueck::-webkit-outer-spin-button,#ypam-stueck::-webkit-inner-spin-button{-webkit-appearance:none!important;margin:0!important;display:none!important}'+
      '#ypam-chips{gap:4px!important;margin-bottom:8px!important}'+
      '#ypam-chips .ypam-chip:hover{border-color:#272726!important;background:#F0F2EF!important;color:#282727!important}'+
      '#ypam-chips .ypam-chip.sel{background:#272726!important;color:#fff!important;border-color:#272726!important}'+
      '#ypam-stueck-wrap{display:flex!important;align-items:center!important;border:1.5px solid #CDD0D4!important;overflow:hidden!important;transition:border-color .2s!important;height:60px!important;box-sizing:border-box!important}'+
      '#ypam-stueck-wrap:focus-within{border-color:#282727!important}'+
      '#ypam-stueck{width:100%!important;height:100%!important;padding:0 12px!important;font-size:13px!important;font-weight:400!important;border:none!important;background:#F8F9F7!important;color:#282727!important;outline:none!important;font-family:var(--font-body-family)!important;-webkit-appearance:none!important;-moz-appearance:textfield!important;appearance:none!important;line-height:normal!important;vertical-align:middle!important;display:block!important;box-sizing:border-box!important}'+
      '#ypam-stueck-unit{font-size:13px!important;color:#ADB2AF!important;font-weight:400!important;display:flex!important;align-self:center!important;height:auto!important;padding:0!important;border:none!important;background:transparent!important;margin-bottom:0!important}'+

      /* ── ZEITPLAN-SECTION: AUSGEBLENDET ─────────────────────────
         Um Zeitplan wieder einzublenden:
         1. Die nächste display:none-Regel entfernen
         2. Im HTML-Block unten den auskommentierten Zeitplan-Block einkommentieren
         3. Im submit-Handler die Zeitplan-Validierung einkommentieren
         4. Schritt-Nummern anpassen: Kontakt = 3, Wünsche = 4
      ─────────────────────────────────────────────────────────── */
      '#ypam-dg{display:none!important}'+

      '#ypam-seg{display:flex!important;background:rgba(107,131,145,0.25)!important;border-radius:8px 8px 0 0!important;padding:4px!important;gap:4px!important;margin-bottom:0!important;cursor:pointer!important}'+
      '#ypam-seg+#ypam-seg-desc{border-radius:0 0 8px 8px!important;margin-bottom:10px!important}'+
      '#ypam-seg:not(:has(+#ypam-seg-desc.visible)){border-radius:8px!important;margin-bottom:10px!important}'+
      '.ypam-zp-btn{flex:1!important;padding:8px 3px!important;font-size:10px!important;font-weight:700!important;border:none!important;background:#6B8391!important;color:#fff!important;border-radius:5px!important;cursor:pointer!important;text-align:center!important;transition:all .15s!important;font-family:var(--font-body-family)!important;clip-path:none!important;-webkit-clip-path:none!important;line-height:1.2!important;height:auto!important;min-height:0!important;text-transform:none!important;letter-spacing:0!important;-webkit-tap-highlight-color:rgba(0,0,0,0)!important;user-select:none!important;-webkit-user-select:none!important}'+
      '#ypam-seg .ypam-zp-btn:hover{background:#3D5260!important}'+
      '.ypam-zp-btn.sel{}'+
      '#ypam-seg-desc{font-size:11px!important;color:#2E4450!important;padding:8px 12px!important;background:rgba(107,131,145,0.25)!important;border-radius:0 0 8px 8px!important;border:none!important;line-height:1.5!important;display:none!important;font-style:italic!important;margin-top:0!important;margin-bottom:10px!important}'+
      '#ypam-seg-desc.visible{display:block!important}'+
      '#ypam-zw{width:100%!important;border:1.5px solid #CDD0D4!important;padding:10px 14px!important;font-size:13px!important;color:#282727!important;resize:none!important;height:62px!important;outline:none!important;background:#F8F9F7!important;display:block!important;margin-bottom:22px!important;transition:border-color .2s!important}'+
      '#ypam-zw:focus{border-color:#282727!important;background:#fff!important}'+
      '#ypam-zw::placeholder{color:#ADB2AF!important}'+
      '.ypam-fr{display:grid!important;grid-template-columns:1fr 1fr!important;gap:14px!important;margin-bottom:16px!important}'+
      '.ypam-fg{display:flex!important;flex-direction:column!important;gap:5px!important}'+
      '.ypam-in{border:none!important;border-bottom:1.5px solid #CDD0D4!important;padding:12px 0!important;font-size:14px!important;color:#282727!important;background:transparent!important;outline:none!important;width:100%!important;transition:border-color .2s!important;border-radius:0!important;box-shadow:none!important}'+
      '.ypam-in:focus{border-bottom-color:#282727!important;box-shadow:none!important}'+
      '.ypam-in::placeholder{color:#8A9098!important;font-size:13px!important}'+
      '#ypam-er{display:none;font-size:12px;color:#c0392b;margin-top:8px}'+
      '#ypam-sb{display:flex!important;width:100%!important;background:#C7D64F!important;color:#282727!important;margin-top:22px!important;justify-content:center!important}'+
      '#ypam-sb:hover{background:#d4e05a!important}'+
      '#ypam-sb:disabled{opacity:.5!important;cursor:not-allowed!important;pointer-events:none!important}'+
      '#ypam-tr,div#ypam-tr{display:flex!important;flex-direction:row!important;justify-content:space-between!important;align-items:center!important;gap:0!important;margin-top:16px!important;flex-wrap:nowrap!important;width:100%!important;padding:0 4px!important}'+
      '.ypam-ti{display:flex!important;align-items:center!important;gap:5px!important;font-size:11px!important;color:#282727!important;flex:1!important;justify-content:center!important}'+
      '.ypam-tc{width:14px!important;height:14px!important;border-radius:50%!important;background:#F0F2EF!important;display:flex!important;align-items:center!important;justify-content:center!important;font-size:8px!important;color:#7a8a70!important;flex-shrink:0!important}'+
      '#ypam-ok{display:none;padding:48px 28px;text-align:center}';

    var mq=document.createElement('style');
    mq.textContent=
      '@media(max-width:600px){'+
        '#ypam-ol{padding:24px 12px!important;align-items:center!important;height:100dvh!important}'+
        '#ypam-bx{height:auto!important;max-height:92dvh!important;min-height:0!important;width:100%!important;border-radius:4px!important;overflow-y:auto!important;box-shadow:0 8px 40px rgba(0,0,0,.35)!important}'+
        '#ypam-hd{padding:12px 40px 12px 14px!important;gap:14px!important;align-items:center!important}'+
        '#ypam-hi{gap:2px!important}'+
        '#ypam-ol .ypam-ey{font-size:9px!important}'+
        '#ypam-ol .ypam-nm{font-size:16px!important}'+
        '#ypam-ol .ypam-ro{font-size:10px!important}'+
        '#ypam-ol .ypam-pm{font-size:10px!important;line-height:1.4!important}'+
        '#ypam-hd>div:first-child{width:62px!important;height:62px!important}'+
        '#ypam-hd>div:first-child img{position:absolute!important;max-width:none!important}'+
        '#ypam-bd{padding:10px 14px 14px!important}'+
        '#ypam-sk{margin-bottom:8px!important}'+
        '#ypam-chips{gap:3px!important}'+
        '.ypam-chip{padding:6px 1px!important;font-size:11px!important}'+
        '#ypam-stueck{font-size:40px!important;width:110px!important}'+
        '#ypam-stueck-wrap{height:64px!important}'+
        '#ypam-stueck-row{align-items:center!important}'+
        '#ypam-stueck-unit{font-size:14px!important}'+
        '#ypam-minus,#ypam-plus{width:30px!important;height:30px!important;font-size:18px!important}'+
        '#ypam-dg{margin-bottom:12px!important}'+
        '#ypam-ol .ypam-dt{font-size:10px!important}'+
        '#ypam-ol .ypam-ds{font-size:9px!important}'+
        '#ypam-ol .ypam-sc{margin-bottom:5px!important;margin-top:14px!important;font-size:12px!important}'+
        '#ypam-ol .ypam-sc:first-child{margin-top:6px!important}'+
        '#ypam-ol .ypam-sc-num{width:18px!important;height:18px!important;font-size:9px!important}'+
        '#ypam-ol .ypam-fr{gap:6px!important;margin-bottom:6px!important}'+
        '#ypam-ol .ypam-in{padding:10px 0!important;font-size:16px!important}'+
        '#ypam-ol #ypam-zw{height:50px!important;margin-bottom:8px!important}'+
        '#ypam-sb{margin-top:8px!important;height:42px!important;font-size:13px!important}'+
        '#ypam-tr{margin-top:6px!important}'+
        '#ypam-ol .ypam-ti{font-size:9px!important}'+
        '#ypam-ol .ypam-tc{width:11px!important;height:11px!important;font-size:7px!important}'+
      '}';
    document.head.appendChild(mq);
    document.head.appendChild(s);

    var imgHtml='';
    if(BFREI){
      imgHtml='<img src="'+BFREI+'" class="ypam-if" style="object-position:'+BPOS+';object-fit:cover;" width="80" height="100" loading="lazy">';
    } else if(BKREIS){
      var zkSize=88;
      var zkW=Math.round(zkSize*BZOOM/100);
      var zkH=Math.round(zkSize*BZOOM/100);
      var bposParts=BPOS.split(' ');
      var zkPx=parseFloat(bposParts[0])||50;
      var zkPy=parseFloat(bposParts[1]||'50')||50;
      var zkLeft=Math.round((zkSize-zkW)*(zkPx/100));
      var zkTop=Math.round((zkSize-zkH)*(zkPy/100));
      imgHtml='<div style="width:88px;height:88px;border-radius:50%;overflow:hidden;flex-shrink:0;border:2px solid rgba(39,39,38,.1);position:relative;">'
        +'<img src="'+BKREIS+'" style="width:'+zkW+'px;height:'+zkH+'px;object-fit:cover;position:absolute;left:'+zkLeft+'px;top:'+zkTop+'px;max-width:none;" loading="lazy">'
        +'</div>';
    } else if(KNAME){
      imgHtml='<div class="ypam-ii">'+KNAME[0]+'</div>';
    }

    var el=document.createElement('div');
    el.id='ypam-ol';
    el.innerHTML=
      '<div id="ypam-bx">'+
        '<button id="ypam-x" aria-label="Schließen">&#x2715;</button>'+
        '<div id="ypam-hd">'+
          imgHtml+
          '<div id="ypam-hi">'+
            '<span class="ypam-ey">Euer Ansprechpartner</span>'+
            (KNAME?'<span class="ypam-nm">'+KNAME+'</span>':'')+
            (KTITEL?'<span class="ypam-ro">'+KTITEL+'</span>':'')+
            '<span class="ypam-pm">'+PROMISE+'</span>'+
          '</div>'+
        '</div>'+
        '<div id="ypam-bd">'+
          '<form id="ypam-fm" onsubmit="return false;">'+

            /* ── SCHRITT 1: STÜCKZAHL ── */
            '<div class="ypam-sc"><span class="ypam-sc-num">1</span>Eure gewünschte Stückzahl</div>'+
            '<div id="ypam-prod-label" style="font-size:11px;color:#6E7378;margin-bottom:0px;margin-top:0px;font-weight:500;line-height:1"></div>'+
            '<div id="ypam-sk">'+
              '<div id="ypam-stueck-row">'+
                '<div id="ypam-minus" role="button" aria-label="Weniger"><svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="0" y1="1" x2="14" y2="1" stroke="white" stroke-width="2" stroke-linecap="round"/></svg></div>'+
                '<div id="ypam-stueck-wrap">'+
                  '<input type="number" id="ypam-stueck" min="'+MIN+'" value="'+MIN+'" placeholder="'+MIN+'">'+
                  '<span id="ypam-stueck-unit">Stk.</span>'+
                '</div>'+
                '<div id="ypam-plus" role="button" aria-label="Mehr"><svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"><line x1="7" y1="0" x2="7" y2="14" stroke="white" stroke-width="2" stroke-linecap="round"/><line x1="0" y1="7" x2="14" y2="7" stroke="white" stroke-width="2" stroke-linecap="round"/></svg></div>'+
              '</div>'+
              /* ── CHIPS AUSGEBLENDET (via CSS display:none) ──
                 Zum Reaktivieren: CSS-Regel '#ypam-chips{display:none}' entfernen
              '<div id="ypam-chips">'+
                (function(){
                  var allChips=[10,100,500,1000,2500,5000];
                  if(MIN>10)allChips[0]=MIN;
                  allChips=allChips.filter(function(v){return v>=MIN;});
                  return allChips.map(function(v){
                    return '<div class="ypam-chip" role="button" data-val="'+v+'">'+v.toLocaleString('de-DE')+'</div>';
                  }).join('');
                })()+
              '</div>'+
              ── ENDE CHIPS ── */
              '<div id="ypam-chips"></div>'+ /* leerer Platzhalter damit IDs erhalten bleiben */
            '</div>'+

            /* ── SCHRITT 2 (ZEITPLAN) AUSGEBLENDET (via CSS display:none auf #ypam-dg) ──
               Zum Reaktivieren:
               1. CSS-Regel '#ypam-dg{display:none}' entfernen
               2. Schritt-Nummer Kontakt von 2 → 3, Wünsche von 3 → 4 ändern
               3. Zeitplan-Validierung im submit-Handler einkommentieren
            '<div class="ypam-sc"><span class="ypam-sc-num">2</span>Wählt euren Zeitplan</div>'+
            '<div id="ypam-dg">'+
              '<div id="ypam-seg">'+
                '<div class="ypam-zp-btn" role="button" data-idx="0" data-v="'+D1+'">'+D1+'</div>'+
                '<div class="ypam-zp-btn" role="button" data-idx="1" data-v="'+D2+'">'+D2+'</div>'+
                '<div class="ypam-zp-btn" role="button" data-idx="2" data-v="'+D3+'">'+D3+'</div>'+
                '<div class="ypam-zp-btn" role="button" data-idx="3" data-v="'+D4+'">'+D4+'</div>'+
              '</div>'+
              '<div id="ypam-seg-desc"></div>'+
            '</div>'+
            ── ENDE ZEITPLAN ── */
            /* Platzhalter damit JS-Referenzen erhalten bleiben */
            '<div id="ypam-dg" style="display:none"><div id="ypam-seg"><div class="ypam-zp-btn" data-idx="0" data-v="'+D1+'">'+D1+'</div><div class="ypam-zp-btn" data-idx="1" data-v="'+D2+'">'+D2+'</div><div class="ypam-zp-btn" data-idx="2" data-v="'+D3+'">'+D3+'</div><div class="ypam-zp-btn" data-idx="3" data-v="'+D4+'">'+D4+'</div></div><div id="ypam-seg-desc"></div></div>'+

            /* ── SCHRITT 2: KONTAKT (war 3) ── */
            '<div class="ypam-sc"><span class="ypam-sc-num">2</span>Kontakt</div>'+
            '<div class="ypam-fr">'+
              '<div class="ypam-fg"><input class="ypam-in" type="text" id="ypam-na" placeholder="Name *"></div>'+
              '<div class="ypam-fg"><input class="ypam-in" type="text" id="ypam-fi" placeholder="Firma *"></div>'+
            '</div>'+
            '<div class="ypam-fr">'+
              '<div class="ypam-fg"><input class="ypam-in" type="email" id="ypam-em" placeholder="E-Mail *"></div>'+
              '<div class="ypam-fg"><input class="ypam-in" type="tel" id="ypam-te" placeholder="Telefon (optional)"></div>'+
            '</div>'+

            /* ── SCHRITT 3: WÜNSCHE (war 4) ── */
            '<div class="ypam-sc"><span class="ypam-sc-num">3</span>Eure Wünsche <span style="font-weight:400;letter-spacing:0;text-transform:none;font-size:10px;opacity:.6">(optional)</span></div>'+
            '<textarea id="ypam-zw" placeholder="Anlass, Ideen, Fragen, besondere Wünsche \u2026"></textarea>'+

            '<div id="ypam-er">Bitte alle Pflichtfelder ausfüllen.</div>'+
            '<button type="button" id="ypam-sb" class="btn btn--primary"><span id="ypam-st">'+MODALBTNTEXT+'</span></button>'+
            '<div id="ypam-tr">'+
              '<div class="ypam-ti"><div class="ypam-tc">\u2713</div>'+TRUST1+'</div>'+
              '<div class="ypam-ti"><div class="ypam-tc">\u2713</div>'+TRUST2+'</div>'+
              '<div class="ypam-ti"><div class="ypam-tc">\u2713</div>'+TRUST3+'</div>'+
            '</div>'+
          '</form>'+
        '</div>'+
      '</div>';
    document.body.appendChild(el);

    function close(){
      el.classList.remove('on');
      document.body.style.overflow='';
      var vp=document.querySelector('meta[name="viewport"]');
      if(vp&&vp._ypOrig)vp.content=vp._ypOrig;
    }
    document.getElementById('ypam-x').onclick=close;
    el.addEventListener('click',function(e){if(e.target===this)close();});

    var ypChipVals=(function(){
      var base=[10,100,500,1000,2500,5000];
      if(MIN>10)base[0]=MIN;
      return base.filter(function(v){return v>=MIN;});
    })();
    function ypUpdateChips(val){
      document.querySelectorAll('.ypam-chip').forEach(function(btn){
        if(parseInt(btn.dataset.val)===val){btn.classList.add('sel');}
        else{btn.classList.remove('sel');}
      });
    }
    document.getElementById('ypam-chips').addEventListener('click',function(e){
      var chip=e.target.closest('.ypam-chip');
      if(!chip)return;
      var v=parseInt(chip.dataset.val);
      if(v<MIN)return;
      document.getElementById('ypam-stueck').value=v;
      ypUpdateChips(v);
      var sb=document.getElementById('ypam-sb');
      var err=document.getElementById('ypam-er');
      if(sb)sb.disabled=false;
      if(err)err.style.display='none';
    });
    document.getElementById('ypam-stueck').addEventListener('input',function(){
      var v=parseInt(this.value);
      ypUpdateChips(ypChipVals.indexOf(v)>-1?v:-1);
      var btn=document.getElementById('ypam-sb');
      var err=document.getElementById('ypam-er');
      if(v>=10){if(btn)btn.disabled=false;if(err)err.style.display='none';}
    });

    var ypZtVals=[D1,D2,D3,D4];
    var ypSegTexts=[
      d.desc1||'Ihr braucht es schnell — wir priorisieren eure Anfrage sofort.',
      d.desc2||'Gut planbar — wir melden uns mit einem detaillierten Angebot.',
      d.desc3||'Kein Stress — wir können alles in Ruhe abstimmen.',
      d.desc4||'Noch kein Termin? Kein Problem — wir beraten euch gerne unverbindlich.'
    ];
    var ypSegActive=-1;
    function ypSegApplyStyles(){
      document.querySelectorAll('.ypam-zp-btn').forEach(function(b,i){
        if(i===ypSegActive){
          b.style.setProperty('background','transparent','important');
          b.style.setProperty('color','#2E4450','important');
          b.style.setProperty('font-weight','800','important');
        }else{
          b.style.setProperty('background','#6B8391','important');
          b.style.setProperty('color','#fff','important');
          b.style.setProperty('font-weight','700','important');
        }
      });
    }
    function ypSegSelect(btn){
      if(!btn)return;
      var btns=Array.from(document.querySelectorAll('.ypam-zp-btn'));
      ypSegActive=btns.indexOf(btn);
      ypSegApplyStyles();
      var desc=document.getElementById('ypam-seg-desc');
      if(desc){desc.textContent=ypSegTexts[parseInt(btn.dataset.idx)];desc.classList.add('visible');}
      var sb=document.getElementById('ypam-sb');
      var err=document.getElementById('ypam-er');
      if(sb)sb.disabled=false;
      if(err)err.style.display='none';
    }
    var ypSegTouched=false;
    document.getElementById('ypam-seg').addEventListener('touchend',function(e){
      ypSegTouched=true;
      var t=e.changedTouches[0];
      var el=document.elementFromPoint(t.clientX,t.clientY);
      var btn=el&&el.closest?el.closest('.ypam-zp-btn'):null;
      if(btn)ypSegSelect(btn);
      e.preventDefault();
      setTimeout(function(){ypSegTouched=false;},600);
    },{passive:false});
    document.getElementById('ypam-seg').addEventListener('click',function(e){
      if(ypSegTouched)return;
      var btn=e.target.closest('.ypam-zp-btn');
      if(btn)ypSegSelect(btn);
    });
    document.getElementById('ypam-chips').addEventListener('touchend',function(){
      setTimeout(ypSegApplyStyles,50);
    },{passive:true});

    window.ypAdjStueck=function(dir){
      var inp=document.getElementById('ypam-stueck');
      var v=parseInt(inp.value)||0;
      if(dir>0){
        if(v<MIN){v=MIN;}
        else{
          var step;
          if(v<100){step=1;}else if(v<500){step=10;}else{step=100;}
          v=Math.min(99999,v+step);
        }
      }else{
        var step;
        if((v-1)<100){step=1;}else if((v-1)<500){step=10;}else{step=100;}
        v=Math.max(MIN,v-step);
      }
      inp.value=v;
      ypUpdateChips(ypChipVals.indexOf(v)>-1?v:-1);
      var sb=document.getElementById('ypam-sb');
      var err=document.getElementById('ypam-er');
      if(sb)sb.disabled=false;
      if(err)err.style.display='none';
    };

    var ypPressTimer=null,ypRepeatTimer=null;
    function ypStartPress(dir,btn){
      ypAdjStueck(dir);
      if(btn)btn.style.setProperty('background','#6E7378','important');
      ypPressTimer=setTimeout(function(){
        ypRepeatTimer=setInterval(function(){ypAdjStueck(dir);},80);
      },500);
    }
    function ypEndPress(btn){
      clearTimeout(ypPressTimer);
      clearInterval(ypRepeatTimer);
      if(btn)btn.style.setProperty('background','#ADB2AF','important');
    }
    function ypBindPress(btn,dir){
      btn.addEventListener('mousedown',function(e){e.preventDefault();ypStartPress(dir,btn);});
      btn.addEventListener('touchstart',function(e){e.preventDefault();ypStartPress(dir,btn);},{passive:false});
      btn.addEventListener('mouseup',function(){ypEndPress(btn);});
      btn.addEventListener('mouseleave',function(){ypEndPress(btn);});
      btn.addEventListener('touchend',function(){ypEndPress(btn);});
      btn.addEventListener('touchcancel',function(){ypEndPress(btn);});
    }

    function ypFixStueckStyles(){
      var row=document.getElementById('ypam-stueck-row');
      var wrap=document.getElementById('ypam-stueck-wrap');
      var inp=document.getElementById('ypam-stueck');
      var unit=document.getElementById('ypam-stueck-unit');
      var minus=document.getElementById('ypam-minus');
      var plus=document.getElementById('ypam-plus');
      if(!row||!minus)return;
      row.style.setProperty('display','flex','important');
      row.style.setProperty('align-items','flex-end','important');
      row.style.setProperty('justify-content','center','important');
      row.style.setProperty('gap','12px','important');
      row.style.setProperty('margin-top','8px','important');
      row.style.setProperty('margin-bottom','10px','important');
      wrap.style.setProperty('display','inline-flex','important');
      wrap.style.setProperty('align-items','flex-end','important');
      wrap.style.setProperty('gap','6px','important');
      wrap.style.setProperty('border-bottom','1.5px solid #ADB2AF','important');
      wrap.style.setProperty('border-top','none','important');
      wrap.style.setProperty('border-left','none','important');
      wrap.style.setProperty('border-right','none','important');
      wrap.style.setProperty('padding-bottom','4px','important');
      inp.style.setProperty('font-size','40px','important');
      inp.style.setProperty('font-weight','800','important');
      inp.style.setProperty('color','#272726','important');
      inp.style.setProperty('background','transparent','important');
      inp.style.setProperty('border','none','important');
      inp.style.setProperty('outline','none','important');
      inp.style.setProperty('width','120px','important');
      inp.style.setProperty('text-align','center','important');
      inp.style.setProperty('padding','0','important');
      inp.style.setProperty('display','inline-block','important');
      inp.style.setProperty('vertical-align','bottom','important');
      var style=document.getElementById('ypam-no-arrows');
      if(!style){
        style=document.createElement('style');
        style.id='ypam-no-arrows';
        style.textContent='#ypam-stueck::-webkit-outer-spin-button,#ypam-stueck::-webkit-inner-spin-button{-webkit-appearance:none!important;margin:0!important}#ypam-stueck{-moz-appearance:textfield!important}';
        document.head.appendChild(style);
      }
      unit.style.setProperty('font-size','13px','important');
      unit.style.setProperty('font-weight','400','important');
      unit.style.setProperty('color','#ADB2AF','important');
      unit.style.setProperty('display','flex','important');
      unit.style.setProperty('align-self','flex-end','important');
      unit.style.setProperty('margin-bottom','3px','important');
      unit.style.setProperty('padding-bottom','0','important');
      [minus,plus].forEach(function(btn){
        btn.style.setProperty('width','36px','important');
        btn.style.setProperty('height','36px','important');
        btn.style.setProperty('min-width','36px','important');
        btn.style.setProperty('border-radius','50%','important');
        btn.style.setProperty('border','none','important');
        btn.style.setProperty('background','#ADB2AF','important');
        btn.style.setProperty('font-size','0','important');
        btn.style.setProperty('line-height','0','important');
        btn.style.setProperty('cursor','pointer','important');
        btn.style.setProperty('display','flex','important');
        btn.style.setProperty('align-items','center','important');
        btn.style.setProperty('justify-content','center','important');
        btn.style.setProperty('clip-path','none','important');
        btn.style.setProperty('-webkit-clip-path','none','important');
        btn.style.setProperty('flex-shrink','0','important');
        btn.style.setProperty('padding','0','important');
        btn.style.setProperty('overflow','visible','important');
        btn.style.setProperty('-webkit-tap-highlight-color','rgba(0,0,0,0)','important');
        btn.style.setProperty('user-select','none','important');
        btn.style.setProperty('-webkit-user-select','none','important');
        btn.style.setProperty('margin-bottom','5px','important');
      });
      if(!minus._ypHover){
        minus._ypHover=true;
        minus.addEventListener('mouseenter',function(){this.style.setProperty('background','#6E7378','important');});
        minus.addEventListener('mouseleave',function(){this.style.setProperty('background','#ADB2AF','important');});
        plus.addEventListener('mouseenter',function(){this.style.setProperty('background','#6E7378','important');});
        plus.addEventListener('mouseleave',function(){this.style.setProperty('background','#ADB2AF','important');});
      }
      var mb=document.getElementById('ypam-minus');
      var pb=document.getElementById('ypam-plus');
      if(mb&&!mb._ypPress){mb._ypPress=true;ypBindPress(mb,-1);}
      if(pb&&!pb._ypPress){pb._ypPress=true;ypBindPress(pb,1);}
    }

    var varName='';
    window.ypAnfrageModalOpen=function(){
      ypFixStueckStyles();
      var inp=document.getElementById('ypam-stueck');
      if(inp&&!inp.value)inp.value=MIN;
      setTimeout(function(){
        var u=document.getElementById('ypam-stueck-unit');
        if(u){
          u.style.setProperty('display','flex','important');
          u.style.setProperty('align-self','flex-end','important');
          u.style.setProperty('margin-bottom','3px','important');
          u.style.setProperty('padding-bottom','0','important');
        }
      },100);
      var vp=document.querySelector('meta[name="viewport"]');
      if(vp)vp._ypOrig=vp.content;
      if(vp)vp.content='width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no';
      el.classList.add('on');
      requestAnimationFrame(function(){
        var hd=document.getElementById('ypam-hd');
        var bildCont=hd?hd.children[0]:null;
        var img=bildCont?bildCont.querySelector('img'):null;
        if(img&&bildCont){
          var sz=bildCont.offsetHeight;
          if(sz>0){
            var bposParts=BPOS.split(' ');
            var px=parseFloat(bposParts[0])||50;
            var py=parseFloat(bposParts[1]||'50')||50;
            var zkW=Math.round(sz*BZOOM/100);
            var zkH=Math.round(sz*BZOOM/100);
            img.style.width=zkW+'px';
            img.style.height=zkH+'px';
            img.style.left=Math.round((sz-zkW)*(px/100))+'px';
            img.style.top=Math.round((sz-zkH)*(py/100))+'px';
          }
        }
      });
      document.body.style.overflow='hidden';
      setTimeout(function(){
        var s=document.querySelector('input.product-variant-id,input[name="id"]');
        varName='';
        try{
          // Methode 1: window.meta
          if(window.meta&&window.meta.product&&s){
            var pv=window.meta.product.variants.find(function(v){return String(v.id)===String(s.value);});
            if(pv&&pv.public_title)varName=pv.public_title;
          }
          // Methode 2: Radio-Input — Shopify nutzt "Farbe-1", "Color-1" etc.
          if(!varName){
            var sel=document.querySelector(
              '.product-form__input input[type="radio"]:checked, '+
              'input[name^="Farbe"]:checked, '+
              'input[name^="Color"]:checked, '+
              'input[name^="Colour"]:checked'
            );
            if(sel)varName=sel.value;
          }
          // Methode 3: sichtbarer Variantenname aus Selector-Button
          if(!varName){
            var btn=document.querySelector('.variant-selects .form__label span, [data-option-value][aria-pressed="true"], .swatch-input--active');
            if(btn)varName=(btn.textContent||btn.getAttribute('data-option-value')||'').trim();
          }
        }catch(ex){}
        var pl=document.getElementById('ypam-prod-label');
        if(pl){
          var t=(PROD?PROD:'')+(varName?' · '+varName:'');
          pl.textContent=t;
        }
      },50);
      if(LID&&window.lintrk)window.lintrk('track',{conversion_id:parseInt(LID)});
    };

    document.getElementById('ypam-sb').addEventListener('click',async function(){
      var name=(document.getElementById('ypam-na').value||'').trim();
      var firma=(document.getElementById('ypam-fi').value||'').trim();
      var email=(document.getElementById('ypam-em').value||'').trim();
      var err=document.getElementById('ypam-er');
      if(!name||!firma||!email){err.style.display='block';return;}
      err.style.display='none';
      var btn=this,txt=document.getElementById('ypam-st');
      var stueck=(document.getElementById('ypam-stueck').value||'').trim();
      if(!stueck||parseInt(stueck)<MIN){
        err.textContent='Bitte gebt eine Stückzahl von mindestens '+MIN+' ein.';
        err.style.display='block';
        return;
      }

      /* ── ZEITPLAN-VALIDIERUNG AUSGEBLENDET ──
         Zum Reaktivieren: die nächsten 4 Zeilen einkommentieren
      var dring=ypSegActive>=0?ypZtVals[ypSegActive]:'';
      if(!dring){err.textContent='Bitte wählt euren Zeitplan aus.';err.style.display='block';return;}
      ── ENDE ZEITPLAN-VALIDIERUNG ── */
      var dring=''; /* Zeitplan leer wenn nicht aktiv */

      btn.disabled=true;txt.textContent='Wird gesendet …';
      var zweck=(document.getElementById('ypam-zw').value||'').trim();
      var tel=(document.getElementById('ypam-te').value||'').trim();
      var m=window.location.pathname.match(/\/products\/([^\/?]+)/);
      try{
        if(WU)await fetch(WU,{
          method:'POST',
          headers:{'Content-Type':'application/json'},
          body:JSON.stringify({action:'send_notification',data:{
            kanal:SK||undefined,name,firma,email,
            telefon:tel,stueck,dringlichkeit:dring,zweck,
            variante:varName,produkt:PROD||(m?m[1]:''),
            quelle:'Anfrage-Button'
          }})
        });
        window.location.href=DANKE;
      }catch(e){
        btn.disabled=false;txt.textContent=MODALBTNTEXT;
        err.textContent='Fehler. Bitte erneut versuchen.';
        err.style.display='block';
      }
    });
  }

  function wait(){
    if(document.getElementById('ypam-host')){boot();}
    else if(document.readyState!=='complete'){setTimeout(wait,100);}
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',wait);
  } else {
    wait();
  }
})();